<template>
    <div :class="['d-flex' ,'flex-column','pr-2']" aria-current="true">
        <div class="d-flex flex-row flex-fill p-1">
            <div class="LineCenter align-self-center"></div>
            <div :class="{'select-item':hasSubItems, 'align-self-center':true,'LineCenter-long':!hasSubItems }" @click="checkBom(Bom)" >
                <i class="bi bi-plus-square" v-if="!Bom.isCheck && hasSubItems"></i>
                <i class="bi bi-dash-square" v-if="Bom.isCheck && hasSubItems"></i>
                 
            </div>
            <!-- <div v-if="Bom.Bom && Bom.Bom.length>0">
                <div class="small">
                    <i class="bi bi-plus-circle"></i>
                </div>
            </div> -->
            <div class="CanClick d-flex flex-row" @click="changeInvQuery(Bom)">
                <span class="StockCodeText small ">
                    {{Bom.Component}} ( {{qtyFormat( Bom.QtyPer)}} )
                </span>
                <span class="DescriptionText small pl-1">{{Bom.Description}} </span> 
            </div>
            
            <span class="MediaIcon flex-shrink-1 small" v-if="Bom.Media.length>0">
                <MediaIconVue v-for="x in Bom.Media" :key="x.ObjectText" :MediaObject="x"></MediaIconVue>
            </span>

        </div>
        <div v-show="Bom.isCheck" >
            <div :class="[levelGray,'d-flex','flex-column','ml-2',hasBoardDown,'pr-2']" v-if="Bom.Bom && Bom.Bom.length>0" >
                <TreeStockCode v-for="b in Bom.Bom" :key="b.Component" :Bom="b" :Level="nextLevel"></TreeStockCode>
            </div> 
        </div>
    </div>
</template>

<script>
import MediaIconVue from './MediaIcon.vue'
 
export default { 
    name: "TreeStockCode",
    props: { Bom: Object,Level:Number},
    components: {
    MediaIconVue
  },
  computed: {
    nextLevel(){
            return Number(this.Level)+1
        },
    levelGray() {
        let grayArray =["bg-gray-300","bg-gray-400","bg-gray-500","bg-gray-600","bg-gray-700","bg-gray-800","bg-gray-900","bg-gray-100","bg-gray-200"]
        let idx = this.Level
        if(this.Level>grayArray.length){
            idx = Number(this.Level/grayArray.length).toFixed(0);
        }
        return grayArray[idx];
    },
    hasSubItems(){
        return this.Bom.Bom && this.Bom.Bom.length>0
    },
    hasBoardDown(){
        return this.Bom.Bom && this.Bom.Bom.length>0?'border-left':'border-left-none'
    }
  },
  methods:{
    changeInvQuery(Bom){
        this.$store.commit("bomStockCode/setSelectSockCode",Bom.Component)
    },
    qtyFormat(Num){
        return Number(Num).toFixed(3)
    },
    checkBom(bom){
        bom.isCheck=!bom.isCheck
    }
  }
}
</script>

<style>
.pl-1{
    padding-left: 5px;
}
.CanClick{
    cursor: pointer;
}
.select-item{
    cursor: pointer;
    width: 20px;
}
.LineCenter-long{
    border-top-style: dashed;
    border-top-width: 1px;
    width: 20px;
    height: 100%;
    padding-right: 2px;
}
.ml-2{
    margin-left: 15px;
}
.border-left{
    border-left-style: dashed;
    border-left-width: 1px;
}
.LineCenter{
    border-bottom-style: dashed;
    border-bottom-width: 1px;
    width: 5px;
    height: 100%;
}
.pr-2{
    padding-right: 5px;
    padding-bottom: 5px;
}
.bg-gray-100{
    background-color: var(--bs-gray-100);
}
.bg-gray-200{
    background-color: var(--bs-gray-200);
}
.bg-gray-300{
    background-color: var(--bs-gray-300);
}
.bg-gray-400{
    background-color: var(--bs-gray-400);
}
.bg-gray-500{
    background-color: var(--bs-gray-500);
    font-weight: bold;
}
.bg-gray-600{
    background-color: var(--bs-gray-400);
    font-weight: normal;
}
.bg-gray-700{
    background-color: var(--bs-gray-300);
    font-weight: normal;
}
.bg-gray-800{
    background-color: var(--bs-gray-200);
    font-weight: normal;
}
.bg-gray-900{
    background-color: var(--bs-gray-100);
    font-weight: normal;
} 
</style>